import { useSitecore } from '@sitecore-content-sdk/nextjs';
import { Base } from '@generated/Foundation.GMI.model';

export function useSitecorePage<T extends Base.BasePage_Route = Base.BasePage_Route>() {
  const { page } = useSitecore();

  return page?.layout?.sitecore?.route as Base.BasePage_Route as T;
}
